// translations/pages/events/uk.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageUK = {
  title: 'Події',
  upcoming: 'Майбутні події',
  past: 'Минулі події',
  all: 'Усі події',
  items: {
    wikki26: {
      title: 'WiKKI26 — конференція зі штучного інтелекту у Вільдау',
      description: 'Компанія pAIoneer Labs була представлена як експонент у Technische Hochschule Wildau. На стенді йшлося про те, як у компаніях та організаціях будують локальну ШІ-інфраструктуру: суверенітет даних, захист даних на етапі проєктування та ШІ, що відповідає правовим вимогам, без зайвої залежності від зовнішніх хмарних рішень.'
    }
  }
};
